module.exports = __webpack_public_path__ + "static/media/tecnomyllogo.368a0750.jpg";